import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

export const SendCampaignDialog = ({ open, onOpenChange, onConfirm, sending }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Send Campaign</AlertDialogTitle>
        <AlertDialogDescription>
          Are you sure you want to send this campaign? Emails will be sent to all selected recipients.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={sending}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          disabled={sending}
          className="bg-orange-600 hover:bg-orange-700"
          data-testid="confirm-send-btn"
        >
          {sending ? (
            <span className="flex items-center gap-2">
              <Loader2 className="w-4 h-4 animate-spin" />
              Sending...
            </span>
          ) : (
            "Send Campaign"
          )}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const DeleteCampaignDialog = ({ open, onOpenChange, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Delete Campaign</AlertDialogTitle>
        <AlertDialogDescription>
          Are you sure you want to delete this campaign? This action cannot be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          className="bg-red-600 hover:bg-red-700"
          data-testid="confirm-delete-campaign-btn"
        >
          Delete
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const CancelScheduledDialog = ({ open, onOpenChange, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Cancel Scheduled Campaign</AlertDialogTitle>
        <AlertDialogDescription>
          Are you sure you want to cancel this scheduled campaign? It will be returned to draft status and you can reschedule it later.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Keep Scheduled</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          className="bg-purple-600 hover:bg-purple-700"
          data-testid="confirm-cancel-campaign-btn"
        >
          Cancel Campaign
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default {
  SendCampaignDialog,
  DeleteCampaignDialog,
  CancelScheduledDialog
};
